import React from "react";
import {
  Row,
  Col,
  message,
  Button,
  Space,
  Modal,
  Image,
  Drawer,
  Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { FileOutlined, CloseOutlined } from "@ant-design/icons";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import withRouter from "../withRouter";
import SubGroupStore from "../store/VehicleSubgroupStore";
import VehicleSubGroupAdd from "./VehicleSubGroupAdd";
import CompanyStore from "../store/CompanyStore";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import config from "../config";

class VehicleSubgroup extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.vehicleSubgrpStore = new SubGroupStore(this);
    this.companyStore = new CompanyStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      openConfirm: false,
      confirmLoading: false,
      companyId: "",
      loadData: 0,
      listDataUpdate: false,
      openGroupAddFom: false,
      deviceSubGroupId: "",
      comp_value: "",

      openDeleteModal: false,
      deleteData: {},
    };

    this.columns = [
      {
        // title: "  Device",
        title: context.translate("_DEVICE_"),
        dataIndex: "subgroupname",
        width: 80,
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Link
              style={{ color: "#2563EB", textDecoration: "none" }}
              onClick={(e) => {
                e.preventDefault();
                this.props.canUpdate("vehiclesubgrouplist") &&
                  this.onEdit(record);
              }}
            >
              &nbsp;{value}
            </Link>
          );
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        key: "Action",
        align: "center",
        // fixed: 'right',
        width: 20,
        ellipsis: {
          showTitle: true,
        },
        render: (_, record) => {
          return (
            <>
              <Space>
                {/* <DeleteConfirm
                  onConfirm={(e) => {
                    e.preventDefault();
                    this.onDelete(record);
                  }}
                >
                  <Link>
                    <Tooltip
                      // title="Remove Device"
                      title={this.context.translate(
                        "_FLEET_GROUP_GROUPLIST_DELETE_"
                      )}
                      color={config.tooltipColorDelete}
                      placement="bottom"
                    >
                      <DeleteFilled style={{ color: config.deleteColor }} />
                    </Tooltip>
                  </Link>
                </DeleteConfirm> */}

                <Tooltip
                  title={this.context.translate(
                    "_FLEET_COMPANY_COMPANYLIST_EDIT_",
                  )}
                  // color={config.tooltipColorDelete}
                  placement="bottom"
                >
                  {this.props.canUpdate("vehiclesubgrouplist") && (
                    <Image
                      style={{
                        height: "19px",
                        width: "15px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
                  )}
                </Tooltip>
                <Tooltip
                  title={this.context.translate(
                    "_FLEET_COMPANY_COMPANYLIST_DELETE_",
                  )}
                  // color={config.tooltipColorDelete}
                  placement="bottom"
                >
                  {this.props.canDelete("vehiclesubgrouplist") && (
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  )}
                </Tooltip>
              </Space>
            </>
          );
        },
      },
    ];
  }
  onEdit = async (record) => {
    await this.context.viewStateStore.setSubgroupStates({
      companyId: record.companyId,
    });
    this.setState({ openGroupAddFom: true });
    this.setState({ deviceSubGroupId: record.deviceSubGroupId });
  };

  async onDelete(record) {
    const response = await this.vehicleSubgrpStore.deleteRecord({
      deviceSubGroupId: record.deviceSubGroupId,
    });
    //  console.log(response.data.success)
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const setGroupData = this.context.viewStateStore.subGroupObject;

      if (setGroupData !== "") {
        await this.vehicleSubgrpStore.loadData({
          companyId: this.state.companyId?.companyId
            ? this.state.companyId?.companyId
            : this.state.companyId,
        });

        const singleData =
          await this.companyStore.getCompanyDataById(setGroupData);

        await this.setState({ loadList: 1 });

        await this.setState({
          comp_value: singleData,
          companyId: setGroupData.companyId
            ? setGroupData.companyId
            : setGroupData,
        });
      }
      await this.setState({ listDataUpdate: false });
    }
  }

  async componentDidMount() {
    // await this.vehicleGroupStore.loadData({ offset: 0, limit: 50 });
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }
    this.setState({ pageSize: 50 });
  }

  async handleTableChange(pagination, filters, sorter) {
    // console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      pageSize: 50,
      currentPage: 1,
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);

    await this.setState({ comp_value: singleData });
    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.vehicleSubgrpStore.loadData({
      companyId: this.state.companyId,
    });
    await this.setState({ loadData: 1, loading: false });
  }
  responseMsg = async (resp) => {
    if (resp.data.success === "S") {
      message.success(resp.data.message);
      this.setState({ openGroupAddFom: false });
      this.setState({ listDataUpdate: true });
      await this.handleSearch();
    } else if (resp.data.success === "F4000") {
      message.error("Subgroup already exists");
    }
  };

  closeModal = () => {
    this.setState({ openGroupAddFom: false, vehicleGroupId: "" });
  };

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.vehicleSubgrpStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
      });
    }
    this.setState({ loading: false, currentPage: 1 });
  };

  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  // allowClear={true}
                  onChange={(value) => this.handleChange(value)}
                  value={this.state.comp_value ? this.state.comp_value : null}
                  style={{ width: 200 }}
                />
              </Space>
            </Col>
            <Col
              span={8}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    alignItems: "center",
                    cursor: "pointer",
                    marginInlineEnd: "20px",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>
              {this.props.canCreate("vehiclesubgrouplist") && (
                <Button
                  className="addButtonClass"
                  onClick={() => {
                    this.setState({
                      openGroupAddFom: true,
                      deviceSubGroupId: "",
                    });
                  }}
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
                  {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                </Button>
              )}
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.vehicleSubgrpStore?.total}
            columns={this.columns}
            dataSource={this.vehicleSubgrpStore?.vehicleSubgrpData}
            loading={this.vehicleSubgrpStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openGroupAddFom && (
          // <Modal
          //   bodyStyle={{ height: "645px" }}
          //   className="formShowModal"
          //   title={this.context.translate("_FLEET_GROUP_GROUPDETAIL_TITLE_")}
          //   centered
          //   visible={this.state.openGroupAddFom}
          //   footer={null}
          //   onCancel={() => {
          //     this.setState({ openGroupAddFom: false, deviceSubGroupId: "" });
          //   }}
          //   width={665}
          // >
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openGroupAddFom}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_SUB_GROUP_DETAILS_")}
                <p className="formDescription">
                  {this.context.translate("_VEHICLE_SUBGROUP_ADD_FORM_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openGroupAddFom: false })}
            onCancel={() =>
              this.setState({ openGroupAddFom: false, deviceSubGroupId: "" })
            }
          >
            <div style={{ height: "100%" }}>
              <VehicleSubGroupAdd
                deviceSubGroupId={this.state.deviceSubGroupId}
                companyId={this.state.companyId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
VehicleSubgroup.contextType = StoreContext;
export default observer(withRouter(VehicleSubgroup));
